var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAdmin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 20.8H4.6c-.5 0-.9-.3-1-.8L1 6.2c-.1-.4.1-.8.4-1 .4-.2.8-.2 1.2 0l4.5 3.1 4.1-5.7c.4-.5 1.3-.5 1.6 0l4.1 5.7 4.5-3.1c.3-.2.8-.2 1.1 0 .3.2.5.6.4 1L20.4 20c-.1.5-.5.8-1 .8zm-14-2h13.1l2-10.5-3.3 2.3c-.4.3-1.1.2-1.4-.2L12 4.9l-3.8 5.4c-.3.4-.9.6-1.4.2L3.4 8.3l2 10.5z"
  })));
}

export default SvgIconAdmin;